import React from 'react';
import ReactDOM from 'react-dom';
import axios from 'axios';
import App from '.';
import { RENDER_CONTEXT } from './constants/renderContext';
import './services/i18n';

function mountSignupLoginModule(rootEl, props) {
  const CsrfToken = document
    .querySelector('meta[name=csrf-token]')
    ?.getAttribute('content');
  const { resetKey, ...appProps } = props || {};

  if (CsrfToken) {
    axios.defaults.headers.common['X-CSRF-Token'] = CsrfToken;
  }

  ReactDOM.render(
    <div className="signup-login-v2 signup-login-v2--is-module">
      <div className="page-inner">
        <App
          key={resetKey}
          {...appProps}
          renderContext={RENDER_CONTEXT.ONE_PAGE_STORE_POPUP}
        />
      </div>
    </div>,
    rootEl,
  );
}

function unmountSignupLoginModule(rootEl) {
  ReactDOM.unmountComponentAtNode(rootEl);
}

export default function createSignupLoginModule(props) {
  return {
    mount(rootEl) {
      mountSignupLoginModule(rootEl, props);
    },
    unmount(rootEl) {
      unmountSignupLoginModule(rootEl);
    },
  };
}

export { mountSignupLoginModule, unmountSignupLoginModule };
